import axios from 'axios'

// let clearedAxios = axios.create()

export const getMediaUrl = id => axios.get(`/media/${id}/url`)
export const getMedia = id =>
  axios.get(`/media/${id}`, {
    responseType: 'blob',
    headers: { 'cache-control': 'no-cache' }
  })
export const getRawMedia = id => axios.get(`/media/${id}`)

export const getUrlResource = urlResource =>
  axios.get(urlResource, {
    responseType: 'blob',
    transformRequest: (data, headers) => {
      delete headers.Authorization
      return data
    }
  })

export const getResourceFromAws = async resourceID => {
  try {
    const { data } = await getMediaUrl(resourceID)
    const resourceURL = data[0]
    const resource = await getUrlResource(resourceURL)
    return resource
  } catch (error) {
    throw error
  }
}

export const getThumbnail = (id, size) => axios.get(`/media/${id}/thumbnail_${size}/url`)
export const postNotificationAlert = (data) => axios.post(`/notification_alerts`, data)
